export default __webpack_public_path__ + "static/media/about.0290bb5a.png";